import $ from 'jquery';

export default class TemplateListCollections {
  constructor(options) {
    this.el = options.el;
    this.$el = $(this.el);

    this.timeout = setTimeout(
      () => this.verticallyAlign()
      , 500,
    );

    $(window).on('resize.list-collections', () => this.verticallyAlign());
  }

  verticallyAlign() {
    const $collections = $('.collection', this.el);

    for (let i = 0; i < $collections.length; i++) {
      const $collection = $($collections[i]);
      const $labels = $collection.find('h2');

      for (let j = 0; j < $labels.length; j++) {
        const $label = $($labels[j]);

        $label
          .css({ marginTop: $label.height() / -2 })
          .removeClass('preload');
      }
    }
  }

  unload() {
    clearTimeout(this.timeout);
    $(window).on('resize.list-collections', () => this.verticallyAlign());
  }
}
